import { Component } from '@angular/core';

@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.css'],
    standalone: false
})
export class SubscriptionComponent {

}
